<div class="dialog-container-W750-H600" style="overflow: auto; height: calc(100% - 15%) !important; max-width: 100% !important">
  <form [formGroup]="taskForm" class="bg-white">
    <div class="flex justify-between" style="border-bottom: 1px solid #53565b22; margin: 0 -24px 12px -24px; padding: 0 24px">
      <div>
        <h3 style="font-family: Open Sans; font-size: 20px; font-weight: 700; line-height: 30px; text-align: left">Manage Task</h3>
      </div>
      <div class="flex flex-row" style="margin-bottom: 0.5rem">
        <div class="status-progress" *ngIf="taskForm.controls['taskStatusProgress'].value">
          <mat-select
            name="status"
            class="{{
              taskForm.controls['taskStatusProgress'].value === 'notstarted'
                ? 'small-notstarted notstarted'
                : '' || taskForm.controls['taskStatusProgress'].value === 'inprogress'
                ? 'small-inprogress inprogress'
                : '' || taskForm.controls['taskStatusProgress'].value === 'complete'
                ? 'small-complete complete flex items-center'
                : ''
            }} flex items-center"
            [disableOptionCentering]="true"
            panelClass="status-panel"
            formControlName="taskStatusProgress"
            [style.backgroundColor]="
              taskForm.controls['taskStatusProgress'].value == 'inprogress'
                ? status[1].backgroundColor
                : '' || taskForm.controls['taskStatusProgress'].value == 'notstarted'
                ? status[0].backgroundColor
                : '' || taskForm.controls['taskStatusProgress'].value == 'complete'
                ? status[2].backgroundColor
                : ''
            "
            [style]="{
                width: '100%',
                height: '30px !important',
                padding: '10px 10px',
                borderRadius: '5px',
                display: 'flex',
                
                position: 'relative',
               
              }"
            (selectionChange)="mode == 'edit' && updateChecklistTask('taskStatusProgress')"
          >
            <mat-option *ngFor="let stat of status" [ngClass]="stat.value" [value]="stat.value">
              <div [style]="{ height: '37px', width: 'fit-content' }" class="flex items-center">
                <span [style.color]="stat.color">
                  {{ stat.displayText }}
                </span>
              </div>
            </mat-option>
          </mat-select>
        </div>
        <button class="closebtn bg-white" (click)="closeSideNav()">
          <span class="material-icons relative bg-white text-[#25508e] text-2xl">clear</span>
        </button>
      </div>
    </div>
    <div class="checklist-sidenav__body" style="height: calc(80vh - 120px); overflow: auto; margin-right: -6px; padding-right: 6px">
      <div class="task__name-wrapper">
        <p class="title">Task name</p>

        <div class="app__discovery--header--search--field mt-[15px] mb-[20px] bg-[#FFFFFF]">
          <div
            class="app__centered-item w-full h-full"
            [ngClass]="{
              'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
            }"
          >
            <input
              class="h-full w-full ml-2 border-none outline-none custom-disabled-field"
              #taskName
              id="taskNameInput"
              type="text"
              name="taskName"
              autofocus
              formControlName="taskName"
              placeholder="Untitled Task"
              [disabled]="isTaskCreator"
              [readonly]="
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
              "
              (keyup.enter)="data?.mode == 'edit' && !isEventInProgress && updateChecklistTask('name')"
              [ngClass]="{
                'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
              }"
              (change)="data?.mode == 'edit' && !isEventInProgress && updateChecklistTask('name')"
            />
          </div>
        </div>
        <!-- <div class="task__name-field">
          <input
            #taskName
            id="taskNameInput"
            type="text"
            name="taskName"
            formControlName="taskName"
            placeholder="Untitled Task"
            [readonly]="data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete'"
            (keyup.enter)="data?.mode == 'edit' && !isEventInProgress && updateChecklistTask('name')"
            (change)="data?.mode == 'edit' && !isEventInProgress && updateChecklistTask('name')"
          />
        </div> -->
        <!-- (change)="mode == 'edit' && updateChecklistTask('name')" -->
      </div>
      <div class="task__owner-wrapper" [style.marginBottom]="data?.mode == 'edit' ? '20px !important' : ''">
        <div class="task__owner-header d-flex">
          <p class="title">Owner</p>
        </div>
        <div
          class="chip d-flex task__owner-added"
          *ngIf="user.name"
          (click)="
            mode == 'edit'
              ? taskForm.controls['taskStatusProgress'].value != 'complete' && taskDetail?.user_id == loginOwnerUserProfile?.id && changeOwner()
              : changeOwner()
          "
          [style.cursor]="
            (mode == 'edit' && taskDetail?.user_id == loginOwnerUserProfile?.id && taskForm.controls['taskStatusProgress'].value != 'complete') ||
            mode == 'add'
              ? 'pointer'
              : ''
          "
          [ngClass]="{
            'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
          }"
        >
          <span>
            <ngx-avatars
              size="32"
              src="{{ isCustom ? ownerUser?.profile_image_url : loginOwnerUserProfile.image }}"
              name="{{ isCustom ? ownerUser.name : (loginOwnerUserProfile.name | titlecase) }}"
              [round]="true"
              initialsSize="2"
              cornerRadius="40"
              [round]="false"
            ></ngx-avatars>
          </span>
          <span class="ml-1" (click)="isTaskCreator && changeOwner()" [disabled]="!isTaskCreator">
            {{ isCustom ? ownerUser.name : (loginOwnerUserProfile.name | titlecase | truncateStrPipe : 30) }}
          </span>
          <!-- <span class="closebtn" *ngIf="mode == 'edit'" (click)="removeAddedOwner()">&times;</span> -->
        </div>
        <div class="user_selecter" *ngIf="ownerlist">
          <checklist-owner-list
            [currentFormId]="taskForm.controls['vault_user_form_id'].value"
            [loginOwnerUserProfile]="loginOwnerUserProfile"
            [isAlreadyGrant]="taskForm.controls['vault_user_form_id'].value ? false : true"
            (close)="handleClose($event)"
          ></checklist-owner-list>
        </div>
      </div>
      <div class="task__link-wrapper">
        <div class="task__link-header d-flex mt-2">
          <p class="title">Links</p>
        </div>
        <div class="task__link-action" style="padding: 11px 0px !important">
          <div class="d-flex">
            <button *ngIf="!data?.manageTask"
              [class]="
                linkedTemplatetypeObj ||
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? 'disabled_btn'
                  : 'upload_btn'
              "
              style="margin-left: 14px; width: 128px !important"
              [attr.disabled]="
                templatetypeAdded ||
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? true
                  : null
              "
              (click)="!linkedTemplatetypeObj && addTemplateForFormType()"
            >
              <span class="material-icons" [class]="screenWidth > 480 ? 'pr-2' : ''" style="position: relative"> open_in_new </span>
              Shortcut
            </button>
            <button
              #templateAddButton
              [class]="
                linkedTemplateObj ||
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? 'disabled_btn'
                  : 'upload_btn'
              "
              style="width: 128px !important"
              [attr.disabled]="
                templateAdded ||
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? true
                  : null
              "
              (click)="!linkedTemplateObj && addTemplateForForm()"
            >
              <span class="material-icons" [class]="screenWidth > 480 ? 'pr-2' : ''" style="position: relative"> widgets </span>
              Template
            </button>
            <button
              [class]="
                attachedAdded ||
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? 'disabled_btn'
                  : 'upload_btn'
              "
              style="width: 120px !important"
              (click)="!attachedAdded && addAttachment(taskDetail)"
              [attr.disabled]="
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete' ? true : null)
              "
            >
              <span class="material-icons md-18" style="position: relative" [class]="screenWidth > 480 ? 'pr-2' : ''"> attach_file </span>
              Attachment
            </button>
            <button
              [class]="
                (data?.mode == 'add' && taskForm.controls['hyperLink'].value) ||
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                linkedHyperlinkObj ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? 'disabled_btn'
                  : 'upload_btn'
              "
              style="margin-right: 15px; width: 120px !important"
              (click)="!linkedHyperlinkObj && !taskForm.controls['hyperLink'].value && addHyperlinkForTask()"
              [attr.disabled]="
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
                  ? true
                  : null
              "
            >
              <span class="material-icons" [class]="screenWidth > 480 ? 'pr-2' : ''" style="position: relative"> link </span>
              Hyperlink
            </button>
          </div>

          <div class="search__template d-flex" *ngIf="addTemplatetype" style="margin: 0px 10px 0px 10px">
            <div class="app__discovery--header--search--field bg-[#FFFFFF]">
              <div class="w-full h-full px-5" style="display: flex; align-items: center; justify-content: space-between">
                <div>
                  <span> <img src="../../../../../../assets/images/blue-search-icon.svg" /> </span>
                  <input
                    #templateSearchInput
                    type="text"
                    matInput
                    [(ngModel)]="searchTextType"
                    autofocus
                    placeholder="Search Template Types"
                    (input)="searchTemplatetype(templateSearchInput.value)"
                    (click)="searchTemplate(templateSearchInput.value)"
                    class="outline-none ml-1"
                  />
                </div>
                <span (click)="clearAddedShortcut()" class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer font-normal"
                  >clear</span
                >
              </div>
            </div>
          </div>
          <div class="template" *ngIf="addTemplatetype && showDropDown">
            <div class="task__forms" #formDropdown>
              <div class="task__forms-list" *ngIf="shortcutlist; else showTemplateLoader">
                <p style="color: rgb(198, 193, 193); font-size: 15px" *ngIf="filteredShortcutList.length == 0">No results found</p>
                <ul *ngFor="let item of filteredShortcutList">
                  <li class="d-flex justify-content-between" (click)="selectFormForTypeTask(item)">
                    <div class="d-flex list-container">
                      <img src="{{ item?.image }}" width="36px !important;" height="36px !important;" />
                      <div class="pl-3">
                        <p class="form-name" matTooltip="{{ item.type.length > 20 ? item.type : null }}" matTooltipClass="customeTooltip">
                          {{ screenWidth > 480 ? (item.type | truncateStrPipe : 20) : (item.type | truncateStrPipe : 12) }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <ng-template #showTemplateLoader>
                <div class="task__forms-list ph-item mb-[-5px]">
                  <div class="ph-col-12" style="padding: 10px !important">
                    <div class="ph-row">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                    <div class="ph-row mt-2">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                    <div class="ph-row mt-2">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                    <div class="ph-row mt-2">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="search__template d-flex font-normal" *ngIf="addTemplate" style="margin: 0px 10px 0px 10px">
            <div class="app__discovery--header--search--field bg-[#FFFFFF]">
              <div class="w-full h-full px-5" style="display: flex; align-items: center; justify-content: space-between">
                <div>
                  <span> <img src="../../../../../../assets/images/blue-search-icon.svg" /> </span>
                  <input
                    #templateSearchInput
                    type="text"
                    matInput
                    [(ngModel)]="searchText"
                    autofocus
                    placeholder="Search Templates"
                    (input)="searchTemplate(templateSearchInput.value)"
                    (click)="searchTemplate(templateSearchInput.value)"
                    class="outline-none ml-1"
                  />
                </div>
                <span (click)="clearAddedTemplate()" class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer font-normal"
                  >clear</span
                >
              </div>
            </div>
            <!-- <mat-form-field appearance="fill" class="form-design-ui">
            <input
              #templateSearchInput
              type="text"
              matInput
              [(ngModel)]="searchText"
              autofocus
              placeholder="Search templates"
              (input)="searchTemplate(templateSearchInput.value)"
              (click)="searchTemplate(templateSearchInput.value)"
            />
           
          </mat-form-field>
          <div class="search__template-btn">
            <button (click)="clearAddedTemplate()">
              <span class="material-icons md-18"> clear </span>
            </button>
          </div> -->
          </div>
          <div class="template" *ngIf="addTemplate && showDropDown">
            <div class="task__forms" #formDropdown>
              <div class="task__forms-list" *ngIf="formsList; else showTemplateLoader">
                <p
                  style="color: rgb(198, 193, 193); font-size: 15px; text-align: center"
                  *ngIf="(formsList && formsList.length === 0) || (searchText !== '' && (formsList | filterWorkspace : searchText).length === 0)"
                >
                  {{ formsList.length === 0 ? 'No Templates to show' : 'No results found' }}
                </p>
                <ul *ngFor="let item of formsList | filterWorkspace : searchText">
                  <li class="d-flex justify-content-between" (click)="selectFormForTask(item)">
                    <!-- Conditionally render the content based on access and checking state -->
                    <div *ngIf="linkedTemplate !== item || !getAccessTotemplate">
                      <!-- Show content only if item is not the selected one or has access -->
                      <div *ngIf="!(linkedTemplate === item && isCheckingAccess)">
                        <div class="d-flex list-container">
                          <img src="{{ item?.profile_image_url }}" width="36px !important;" height="36px !important;" />
                          <div class="pl-3" style="margin-top: -5px">
                            <p
                              class="form-name"
                              matTooltip="{{ item.form_name.length > 20 ? item.form_name : null }}"
                              matTooltipClass="customeTooltip"
                            >
                              {{ screenWidth > 480 ? (item.form_name | truncateStrPipe : 20) : (item.form_name | truncateStrPipe : 12) }}
                            </p>
                            <div class="d-flex" style="margin-top: -10px">
                              <button style="background-color: #b6c9ee">
                                {{ screenWidth > 480 ? (item?.vault_name | truncateStrPipe : 20) : (item?.vault_name | truncateStrPipe : 7) }}
                              </button>
                              <button class="ml-2" style="background-color: #c8eeb6">
                                {{ screenWidth > 480 ? (item?.section_name | truncateStrPipe : 20) : (item?.section_name | truncateStrPipe : 7) }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Show checking permission message -->
                    </div>
                    <p mat-line *ngIf="linkedTemplate === item && AccessTotemplate">
                      <button class="access_permision-btn">Checking permission...</button>
                    </p>

                    <!-- Show access template if no access -->
                    <ng-template #accessTemplate>
                      <div class="d-flex list-container access_text">
                        {{ isCustom ? ownerUser.name : loginOwnerUserProfile.name }} needs permission to access the attached template.
                      </div>
                      <div class="d-flex">
                        <p mat-line>
                          <button class="access_cancel-btn" (click)="cancelAccess()">Cancel</button>
                        </p>
                        <p mat-line>
                          <button class="select-btn" (click)="shareAccesss(item)">Share</button>
                        </p>
                      </div>
                    </ng-template>

                    <div
                      *ngIf="linkedTemplate === item && getAccessTotemplate"
                      style="display: flex; justify-content: space-between; width: 100%; background: #eaf0f7; height: 57px"
                    >
                      <ng-container *ngTemplateOutlet="accessTemplate"></ng-container>
                    </div>
                  </li>
                </ul>
              </div>
              <ng-template #showTemplateLoader>
                <div class="task__forms-list ph-item mb-[-5px]">
                  <div class="ph-col-12" style="padding: 10px !important">
                    <div class="ph-row">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                    <div class="ph-row mt-2">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                    <div class="ph-row mt-2">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                    <div class="ph-row mt-2">
                      <div class="ph-col-6"></div>
                      <div class="ph-col-2 empty"></div>
                      <div class="ph-col-4"></div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="task__linked-template" *ngIf="linkedTemplatetypeObj">
            <span class="mb-2">Shortcut</span>
            <div class="linked-template" [style.width]="!formLinked ? '98.2% !important' : '99% !important'">
              <div class="d-flex justify-content-between" style="height: 49px">
                <div class="d-flex list-container">
                  <img src="{{ linkedTemplatetypeObj?.profile_image_url }}" width="40px !important;" height="40px !important;" />
                  <div class="pl-3">
                    <p
                      class="form-name mt-2"
                      matTooltip="{{ linkedTemplatetypeObj.shortcut.length > 20 ? linkedTemplatetypeObj.shortcut : null }}"
                      matTooltipClass="customeTooltip"
                    >
                      {{
                        screenWidth > 480
                          ? (linkedTemplatetypeObj.shortcut | truncateStrPipe : 20)
                          : (linkedTemplatetypeObj.shortcut | truncateStrPipe : 12)
                      }}
                    </p>
                    <!-- <div
                    [class]="screenWidth > 480 ? 'flex' : 'block'"
                    style="margin-top: -10px"
                    *ngIf="linkedTemplateObj?.vault_name && linkedTemplateObj?.section_name"
                  >
                    <button style="background-color: #b6c9ee">
                      {{
                        screenWidth > 480
                          ? (linkedTemplateObj?.vault_name | truncateStrPipe : 18)
                          : (linkedTemplateObj?.vault_name | truncateStrPipe : 7)
                      }}
                    </button>
                    <button [class]="screenWidth > 480 ? 'ml-2' : 'mt-1'" style="background-color: #c8eeb6">
                      {{
                        screenWidth > 480
                          ? (linkedTemplateObj?.section_name | truncateStrPipe : 18)
                          : (linkedTemplateObj?.section_name | truncateStrPipe : 7)
                      }}
                    </button>
                  </div> -->
                  </div>
                </div>
                <p style="width: 17%">
                  <span
                    *ngIf="!formLinked"
                    (click)="mode == 'edit' ? removeAddedTemplatetype() : clearAddedShortcut()"
                    [attr.disabled]="data.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete' ? true : null"
                    class="material-icons clear-btn"
                  >
                    clear
                  </span>
                  <button class="select-btn" [class]="screenWidth > 480 ? 'h-[35px]' : 'h-14'" (click)="openFormShortcut(linkedshortcut)">Add</button>
                </p>
              </div>
            </div>
          </div>
          <mat-divider *ngIf="linkedTemplatetypeObj" [class]="'m-4'"></mat-divider>
          <div class="task__linked-template" *ngIf="linkedTemplateObj">
            <span class="mb-2">Template</span>
            <div
              class="linked-template"
              [class]="screenWidth > 480 ? 'h-[72px]' : 'h-24'"
              [style.width]="!formLinked ? '98.2% !important' : '99% !important'"
            >
              <div class="d-flex justify-content-between">
                <div class="d-flex list-container">
                  <img src="{{ linkedTemplateObj?.profile_image_url }}" width="36px !important;" height="36px !important;" />
                  <div class="pl-3" style="margin-top: -5px">
                    <p
                      class="form-name"
                      matTooltip="{{ linkedTemplateObj.form_name.length > 20 ? linkedTemplateObj.form_name : null }}"
                      matTooltipClass="customeTooltip"
                    >
                      {{
                        screenWidth > 480
                          ? (linkedTemplateObj.form_name | truncateStrPipe : 20)
                          : (linkedTemplateObj.form_name | truncateStrPipe : 12)
                      }}
                    </p>
                    <div
                      [class]="screenWidth > 480 ? 'flex' : 'block'"
                      style="margin-top: -10px"
                      *ngIf="linkedTemplateObj?.vault_name && linkedTemplateObj?.section_name"
                    >
                      <button style="background-color: #b6c9ee">
                        {{
                          screenWidth > 480
                            ? (linkedTemplateObj?.vault_name | truncateStrPipe : 18)
                            : (linkedTemplateObj?.vault_name | truncateStrPipe : 7)
                        }}
                      </button>
                      <button [class]="screenWidth > 480 ? 'ml-2' : 'mt-1'" style="background-color: #c8eeb6">
                        {{
                          screenWidth > 480
                            ? (linkedTemplateObj?.section_name | truncateStrPipe : 18)
                            : (linkedTemplateObj?.section_name | truncateStrPipe : 7)
                        }}
                      </button>
                    </div>
                  </div>
                </div>
                <p style="width: 17%; margin-top: 4px !important" *ngIf="!data?.manageTask">
                  <span
                    *ngIf="!formLinked"
                    (click)="mode == 'edit' ? removeAddedTemplate() : clearAddedTemplate()"
                    [attr.disabled]="data.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete' ? true : null"
                    class="material-icons clear-btn"
                  >
                    clear
                  </span>
                  <button class="select-btn mt-1" [class]="screenWidth > 480 ? 'h-[35px]' : 'h-14'" (click)="openForm(linkedTemplate)">View</button>
                </p>
              </div>
            </div>
          </div>
          <mat-divider *ngIf="linkedTemplateObj" [class]="'m-4'"></mat-divider>
          @if(task_id && user&&!is_reload){
          <check-list-task-attachments
            [task_id]="task_id"
            [user]="user"
            [user_id]="taskDetail?.user_id"
            [mode]="data?.mode"
            (attachedAddedChange)="onAttachedAddedChange($event)"
          ></check-list-task-attachments>
          }
          <div class="task__hyperlink d-flex" *ngIf="addHyperlink && !linkedHyperlinkObj">
            <mat-form-field appearance="fill" class="form-design-ui">
              <input type="text" matInput #hyperLink formControlName="hyperLink" placeholder="Enter link" style="font-weight: bold" />
              <button
                style="width: 13%; margin: 0; padding: 0; padding-top: 4px"
                [ngClass]="{
                  'app__btn--disabled ': !hyperLink.value.trim(),
                  'app__btn--primary cursor-pointer': hyperLink.value.trim()
                }"
                [class]="screenWidth > 480 ? 'h-[35px]' : 'h-14'"
                (click)="saveHyperlink()"
              >
                Save
              </button>
              <mat-error *ngIf="taskForm.controls['hyperLink'].value && taskForm.controls['hyperLink'].errors"> Incorrect link format </mat-error>
              <!-- <mat-icon matPrefix>link</mat-icon> -->
            </mat-form-field>
            <!-- <div class="d-flex task__hyperlink-btn">
            <button (click)="saveHyperlink()">
              <span class="material-icons md-18"> done </span>
            </button>
            <button style="margin-left: 10px" (click)="clearAddedHyperlink()">
              <span class="material-icons md-18"> clear </span>
            </button>
          </div> -->
          </div>

          <div class="task__linked-hyperlink" [ngStyle]="!linkedHyperlinkObj ? { margin: '0px 10px 0px 10px' } : {}">
            <span *ngIf="linkedHyperlinkObj; else hyperlinkPlaceholder" class="mb-2">Hyperlink</span>
            <div class="linked-hyperlink" *ngIf="linkedHyperlinkObj; else hyperlinkPlaceholder">
              <div class="d-flex justify-content-between">
                <div class="d-flex hyperlink-container">
                  <div class="hyperlink-icon">
                    <span class="material-icons md-18"> link </span>
                  </div>
                  <div class="pl-3">
                    <p class="form-name" [matTooltip]="linkedHyperlinkObj.external_link_name ?? ''" matTooltipClass="customeTooltip">
                      {{
                        linkedHyperlinkObj.external_link_name
                          ? screenWidth > 480
                            ? (linkedHyperlinkObj?.external_link_name | truncateStrPipe : 30)
                            : (linkedHyperlinkObj?.external_link_name | truncateStrPipe : 12)
                          : 'Unknown'
                      }}
                    </p>
                    <div class="d-flex" style="margin-top: -13px">
                      <p>
                        {{
                          screenWidth > 480
                            ? (linkedHyperlinkObj?.external_link | truncateStrPipe : 45)
                            : (linkedHyperlinkObj?.external_link | truncateStrPipe : 18)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <button
                    class="delete-hyperlink-btn"
                    *ngIf="linkedHyperlinkObj"
                    (click)="removeAddedHyperlink()"
                    [attr.disabled]="data.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete' ? true : null"
                  >
                    <span class="material-icons md-18 font-normal clear-btn" style="margin: 0px 2px 7px 0px"> clear </span>
                  </button>
                  <button class="visit-btn" (click)="openLinkInAnotherTab(linkedHyperlinkObj?.external_link)">Visit</button>
                </div>
              </div>
            </div>
            <ng-template #hyperlinkPlaceholder>
              <div class="loader-container mt-[0px] mb-[-10px]" *ngIf="!addHyperlink && loadHyperlink">
                <div class="flex loader-body">
                  <div class="ph-item width-100per loader-body-item">
                    <div class="ph-col-12 width-85per" style="padding: 0px !important">
                      <div class="ph-row">
                        <div class="ph-col-12" style="height: 30px; margin-top: -5px; border-radius: 4px"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="task__description-wrapper">
        <div class="task__description-header d-flex mt-2">
          <div class="d-flex">
            <p class="title">Description</p>
          </div>
          <!-- <div
            *ngIf="showEditorMenu && data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value != 'complete'"
            class="d-flex task__description-header-btn">
            <button (click)="addDescription()">
              <span class="material-icons"> done </span>
            </button>
            <button class="ml-2" (click)="removeAddedDescription()">
              <span class="material-icons"> clear </span>
            </button>
          </div> -->
        </div>
        <div
          class="task__description-input"
          [ngClass]="{
            'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
          }"
        >
          <div class="editor">
            <div
              class="editor__menu"
              *ngIf="showEditorMenu && (data?.mode == 'edit' ? taskForm.controls['taskStatusProgress'].value != 'complete' : true)"
            >
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
            </div>
            <ngx-editor
              class="w-full"
              [editor]="editor"
              formControlName="taskDesc"
              (click)="onEditDescription()"
              [ngClass]="{
                'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
              }"
              [disabled]="
                (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) ||
                (data?.mode == 'edit' && taskForm.controls['taskStatusProgress'].value == 'complete')
              "
            >
            </ngx-editor>
          </div>
        </div>
      </div>
      <div class="task__date-wrapper" [style.marginTop]="addHyperlink ? '10px' : loadHyperlink ? '0px' : linkedHyperlinkObj ? '25px' : '15px'">
        <!-- [style.marginTop]="addHyperlink || loadHyperlink ? '-25px' : '25px'" -->
        <div class="task__date-header d-flex">
          <p class="title">Timeline</p>
        </div>
        <div class="task__date-input">
          <div class="due_when">
            <div class="flex">
              <button
                class="h-11 rounded mr-1.5"
                (click)="setReminderType('asap')"
                [ngClass]="{
                  time_line_active_btn: taskForm.controls['taskDueWhen'].value == 'asap',
                  time_line_deactive_btn: taskForm.controls['taskDueWhen'].value != 'asap',
                  'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
                }"
                [attr.disabled]="data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id ? true : null"
              >
                ASAP
              </button>

              <button
                class="h-11 rounded mr-1.5"
                (click)="setReminderType('future')"
                [ngClass]="{
                  time_line_active_btn: taskForm.controls['taskDueWhen'].value == 'future',
                  time_line_deactive_btn: taskForm.controls['taskDueWhen'].value != 'future',
                  'gray-background': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id
                }"
                [attr.disabled]="data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id ? true : null"
              >
                On a Future Date
              </button>
            </div>
            @if(taskForm.controls.taskDueWhen.value == 'asap') {
            <mat-form-field
              [floatLabel]="'auto'"
              appearance="fill"
              style="width: 100% !important"
              class="automtic-form-desing-form-only mt-3 disabled-mat-field"
            >
              <mat-label class="automtic-form-desing-lable">Start Date</mat-label>
              <input matInput disabled formControlName="start_date" type="text" />
            </mat-form-field>
            <mat-form-field
              [floatLabel]="'auto'"
              appearance="fill"
              style="width: 100% !important"
              class="automtic-form-desing-form-only disabled-mat-field"
            >
              <mat-label class="automtic-form-desing-lable">Finish Date</mat-label>
              <input matInput disabled formControlName="finish_date" type="text" />
            </mat-form-field>
            } @if(taskForm.controls.taskDueWhen.value == 'future' ) {
            <mat-form-field
              [floatLabel]="'auto'"
              appearance="fill"
              style="width: 100% !important"
              [ngClass]="{
                'disabled-mat-field':
                  taskForm.controls.timeline_future_date_is.value == 'Finish by Date' ||
                  (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id)
              }"
              class="automtic-form-desing-form-only mt-3"
            >
              <mat-label class="automtic-form-desing-lable">Future Date Is</mat-label>
              <mat-select matNativeControl class="example-panel" disableOptionCentering formControlName="timeline_future_date_is">
                @for (item of timeline_type_list; track item) {
                <mat-option [value]="item?.value" class="hide-check-box">
                  {{ item.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field [floatLabel]="'auto'" appearance="fill" style="width: 100% !important"
              [ngClass]="{ 'disabled-mat-field': taskForm.controls.timeline_future_date_is.value == 'Finish by Date' || (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id) }"
              class="automtic-form-desing-form-only">
              <mat-label class="automtic-form-desing-lable">
                <span class="truncate-label">Start Date</span>
              </mat-label>
              <input matInput [matDatepicker]="dp3" (click)="dp3.open()"
                [disabled]="taskForm.controls.timeline_future_date_is.value == 'Finish by Date' || (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id)"
                (dateChange)="addEvent('change', $event)" formControlName="timeline_start_date" />
              <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
              <mat-datepicker #dp3></mat-datepicker>
            </mat-form-field> -->

            <reusable-date-input
              style="width: 100% !important; display: contents"
              [ngClassStyle]="{
                'disabled-mat-field':
                  taskForm.controls.timeline_future_date_is.value == 'Finish by Date' ||
                  (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id)
              }"
              [classStyle]="'automtic-form-desing-form-only w-full'"
              [title]="'Start Date'"
              [hasMaxDate]="false"
              [controlName]="'timeline_start_date'"
              [value]="startDateValue"
              (dateChangeEmitter)="handleDateChange($event, 'timeline_start_date')"
              (changeEmitter)="handleDateChange2($event, 'timeline_start_date')"
            >
            </reusable-date-input>

            <p class="font-semibold text-xs text-[#487AF0]">Time to Complete</p>

            <div class="flex flex-row">
              <mat-form-field
                [floatLabel]="'auto'"
                appearance="fill"
                style="width: 100% !important"
                [ngClass]="{ 'disabled-mat-field': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id }"
                class="automtic-form-desing-form-only mr-1.5"
              >
                <mat-select class="example-panel" matNativeControl disableOptionCentering formControlName="timeline_period">
                  <mat-option value="" class="hide-check-box">Select</mat-option>
                  @for (item of timeline_period_list; track item) {
                  <mat-option [value]="item?.value" class="hide-check-box">
                    {{ item.label }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field
                [floatLabel]="'auto'"
                appearance="fill"
                style="width: 100% !important"
                [ngClass]="{ 'disabled-mat-field': data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id }"
                class="automtic-form-desing-form-only ml-1.5"
              >
                <mat-select class="example-panel" matNativeControl disableOptionCentering formControlName="timeline_period_type">
                  <mat-option value="" class="hide-check-box">Select</mat-option>
                  @for (item of timeline_period_type_list; track item) {
                  <mat-option [value]="item?.value" class="hide-check-box">
                    {{ item.label }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <!-- <mat-form-field
              [floatLabel]="'auto'"
              appearance="fill"
              [ngClass]="{
                'disabled-mat-field':
                  taskForm.controls.timeline_future_date_is.value == 'Start by Date' ||
                  (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id)
              }"
              style="width: 100% !important"
              class="automtic-form-desing-form-only"
            >
              <mat-label class="automtic-form-desing-lable">
                <span class="truncate-label">Finish Date</span>
              </mat-label>
              <input
                matInput
                [matDatepicker]="dp4"
                (click)="dp4.open()"
                [disabled]="
                  taskForm.controls.timeline_future_date_is.value == 'Start by Date' ||
                  (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id)
                "
                (dateChange)="addEvent('change', $event)"
                formControlName="timeline_finish_date"
              />
              <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
              <mat-datepicker #dp4></mat-datepicker>
            </mat-form-field> -->

            <reusable-date-input
              style="width: 100% !important; display: contents"
              [ngClassStyle]="{
                'disabled-mat-field':
                  taskForm.controls.timeline_future_date_is.value == 'Start by Date' ||
                  (data?.mode == 'edit' && taskDetail?.user_id != loginOwnerUserProfile?.id)
              }"
              [classStyle]="'automtic-form-desing-form-only w-full'"
              [title]="'Finish Date'"
              [hasMaxDate]="false"
              [controlName]="'timeline_finish_date'"
              [value]="endDateValue"
              (dateChangeEmitter)="handleDateChange($event, 'timeline_finish_date')"
              (changeEmitter)="handleDateChange2($event, 'timeline_finish_date')"
            >
            </reusable-date-input>

            }
          </div>
        </div>
      </div>

      <!-- <div class="task__activity-wrapper" *ngIf="data?.mode == 'edit'"  [disabled]="!isTaskCreator">
        <manage-activity-log [checklistTaskId]="this.taskDetail.id" [mode]="mode"> </manage-activity-log>
      </div> -->
    </div>
    <div class="save-btn" *ngIf="data?.mode != 'edit'">
      <button
        style="margin-top: 24px !important; margin-bottom: 0px !important"
        mat-raised-button
        type="submit"
        [ngClass]="!is_form_valid ? 'app__btn--disabled mt-0' : 'app__btn--primary mt-0 cursor-pointer'"
        (click)="is_form_valid ? createChecklistTask() : null"
      >
        Save
      </button>
    </div>
    <div class="save-btn" *ngIf="data?.mode == 'edit' && taskDetail?.user_id == loginOwnerUserProfile?.id" [disabled]="!isTaskCreator">
      <button
        style="margin-top: 24px !important; margin-bottom: 0px !important"
        mat-raised-button
        type="submit"
        class="app__btn--primary mt-0 cursor-pointer"
        (click)="updateTask()"
      >
        Update
      </button>
    </div>
  </form>
</div>
@if(addVaultShortcut){
<mat-sidenav
  class="app__report--sidenav--container w-[935px] bg-[#FAFAFA]"
  [mode]="'over'"
  [(opened)]="addVaultShortcut"
  position="end"
  [ngStyle]="data?.mode == 'edit' ? { right: '0', transform: 'none' } : {}"
  [fixedInViewport]="true"
  [fixedTopGap]="0"
>
  <checklist-shortcut-add
    [from]="'section'"
    [selectedTemplate]="linkedshortcut"
    [nameForm]=""
    [folderId]=""
    [subFolderId]=""
    [userId]="loginOwnerUserProfile?.id || taskDetail?.user_id"
    [templatetype]="linkedshortcut.type_template"
    (backClick)="closenavshortcut()"
  ></checklist-shortcut-add>
</mat-sidenav>
}
